const LOGO_DEV_TOKEN = import.meta.env.VITE_LOGO_DEV_TOKEN;

export const LOGO_PLACEHOLDER = '/icons/clean/bank.svg';

export const getLogoUrl = (domain) => {
  if (!domain || !LOGO_DEV_TOKEN) return null;
  return `https://img.logo.dev/${domain}?token=${LOGO_DEV_TOKEN}`;
};
